var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{attrs:{"id":"commonError"}},[_vm._v(_vm._s(_vm._f("localize")("contract_withdrawal.phone.title")))]),_c('p',[_vm._v(_vm._s(_vm._f("localize")("contract_withdrawal.phone.message")))]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.phoneNumber1))]),_c('li',[_vm._v(_vm._s(_vm.phoneNumber2))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }